import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
} from '../../utils/event_constants';

export const textAnonymizationActionData = [
  {
    name: 'nlpAnonymization',
    label: 'NLP Anonymization',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fieldForSourceText', label: 'Select Source Field' }),
      collectionFieldArgsConfig({
        name: 'fieldForAnonymizedText',
        label: 'Select Anonymized Field',
      }),
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'customTermsAnonymization',
    label: 'Custom Terms Anonymization',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'fieldForSourceText', label: 'Select Source Field' }),
      collectionFieldArgsConfig({
        name: 'fieldForCustomTerms',
        label: 'Select Custom Terms Field',
      }),
      collectionFieldArgsConfig({
        name: 'fieldForAnonymizedText',
        label: 'Select Anonymized Field',
      }),
      ...alertMessagesArgsConfig,
    ],
  },
];
